import axios from "axios";
import { fetchAuthSession } from "aws-amplify/auth";
import { persistAuthRedirectPath } from "./auth-redirect.service";

const BASE_URL_V2 = process.env.REACT_APP_BASE_URL_V2;
const BASE_URL_V4 = process.env.REACT_APP_BASE_URL_V4;

const instance = axios.create({ baseURL: BASE_URL_V2 });

instance.defaults.headers.common["tenantId"] = "ren";

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token")
      ? localStorage.getItem("access_token")
      : "";
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    if (config?.includeUserId) {
      config.headers["userId"] = getSSO();
    }
    if (config?.baseUrlv4) {
      config.baseURL = BASE_URL_V4;
    } 
    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

const refreshAndRetryQueue = [];
let isRefreshing = false;
let newAccessToken = "";
let isTokenCall = false;

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response && error.response.status === 401) {
      if (!isRefreshing) {
        isRefreshing = true;
        try {
          if (!isTokenCall) {
            isTokenCall = true;
            try {
              const session = await fetchAuthSession(); //  Get fresh session
              newAccessToken = session.tokens?.accessToken?.toString() || "";

              if (!newAccessToken) {
                throw new Error("Unable to refresh access token");
              }

              localStorage.setItem("access_token", newAccessToken);
            } catch (error) {
              console.error("Silent authentication failed:", error);
              persistAuthRedirectPath();
              window.location.href = process.env.REACT_APP_SSO_LOGIN; // Redirect to login if session is invalid
              return Promise.reject(error);
            }
          }

          error.config.headers["Authorization"] = `Bearer ${newAccessToken}`;

          refreshAndRetryQueue.forEach(({ config, resolve, reject }) => {
            instance
              .request(config)
              .then((response) => resolve(response))
              .catch((err) => reject(err));
          });

          refreshAndRetryQueue.length = 0;
          return instance(originalRequest);
        } catch (refreshError) {
          clearStorage();
          throw refreshError;
        } finally {
          isRefreshing = false;
          isTokenCall = false;
        }
      }

      return new Promise((resolve, reject) => {
        refreshAndRetryQueue.push({ config: originalRequest, resolve, reject });
      });
    }
    return Promise.reject(error);
  },
);

const clearStorage = () => {
  localStorage.clear();
};

export const getSSO = () => {
  return localStorage.getItem("ge_sso");
};

export default instance;
